import axios from 'axios';

const KEY = 'adeeb-admin-token';

export function getAdminToken() {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(KEY);
}

export function setAdminToken(token) {
  if (typeof window === 'undefined') return;
  if (token) { localStorage.setItem(KEY, token); localStorage.setItem('adeeb-admin-expires', String(Date.now() + 2 * 3600000)); }
  else localStorage.removeItem(KEY);
  window.dispatchEvent(new Event('adeeb-admin-session-change'));
}

export function clearAdminToken() {
  setAdminToken(null);
}

// Decode without verifying — just to know the expiry locally so we can
// redirect to /admin/login before making a doomed API call.
export function getAdminTokenInfo() {
  const t = getAdminToken();
  if (!t) return null;
  if (t === 'cookie-session') return { step: 'admin', exp: Number(localStorage.getItem('adeeb-admin-expires') || 0) };
  try {
    const payload = JSON.parse(atob(t.split('.')[1]));
    if (!payload || !payload.exp) return null;
    return { exp: payload.exp * 1000, id: payload.id, step: payload.step };
  } catch { return null; }
}

export function isAdminTokenValid() {
  const info = getAdminTokenInfo();
  if (!info) return false;
  return info.step === 'admin' && info.exp > Date.now();
}

let interceptorRegistered = false;
/**
 * Register a one-time axios interceptor that adds the admin token as
 * X-Admin-Token on every request to /api/admin/*. Also reacts to 401
 * with code ADMIN_STEP_UP_REQUIRED by clearing the local token and
 * dispatching an event so the layout can bounce the user to login.
 */
export function ensureAdminAxiosInterceptor() {
  if (interceptorRegistered || typeof window === 'undefined') return;
  axios.interceptors.request.use((config) => {
    const target = new URL(config.url || '', config.baseURL || window.location.origin);
    if (target.origin !== window.location.origin) return config;
    const url = target.pathname;
    if (/(^|\/)\/?api\/admin\//.test(url) || url.startsWith('/api/admin/') || url.startsWith('/api/discover/admin')) {
      const t = getAdminToken();
      if (t) {
        config.headers = config.headers || {};
        config.headers['X-Admin-Token'] = t;
      }
    }
    return config;
  });
  axios.interceptors.response.use(
    (r) => r,
    (err) => {
      const code = err?.response?.data?.code;
      if (code === 'ADMIN_STEP_UP_REQUIRED' || code === 'ADMIN_STEP_UP_MISMATCH') {
        clearAdminToken();
        window.dispatchEvent(new CustomEvent('adeeb-admin-step-up-needed'));
      }
      return Promise.reject(err);
    }
  );
  interceptorRegistered = true;
}
